import React from 'react';
import { Link } from 'react-router-dom';
import { CORE_SCREENS } from './ScreenData';
import { ScreenShell } from './ScreenShared';

export function ScreensIndex() {
  return (
    <ScreenShell titleBar={<Link className="figma-toplink" to="/">Back</Link>}>
      <h2 className="figma-section-title">Screens</h2>
      <p className="figma-sub">18 core screens mapped from the prototype</p>
      <div className="figma-list">
        {CORE_SCREENS.map((screen) => (
          <Link key={screen.to} to={screen.to} className="figma-list-item figma-link-row">
            <p className="name">{screen.label}</p>
          </Link>
        ))}
      </div>
    </ScreenShell>
  );
}
